module.exports = __webpack_public_path__ + "img/ic_gift_giveaway_no_background.5b42f4ea.svg";